
import {connect} from 'react-redux';
import CustomiseCustomSection from './CustomiseCustomSection';
import {findSection, updateSectionValue} from '../ducks/reportSections';
import * as preferencesActions from '../actionCreators/preferences';
import actionCreators from '../actionCreators/index';

const mapStateToProps = (state, ownProps) => {
  const reportType = state.reportType.value;
  return {
    reportType,
    section: findSection(state.reportSections, reportType, 'CUSTOM', ownProps.url),
    title: ownProps.title,
    url: ownProps.url,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    sendEvent: (section, title) => {
      dispatch(actionCreators.sendEditTitleAnalyticsEvent(section, title));
    },
    updateSectionValue: (title, dataKeyPath, reportType) => {
      dispatch(updateSectionValue({
        key: 'CUSTOM',
        dataKeyPath,
        url: ownProps.url,
        value: title,
        reportType,
      }));
    },
    updatePreferences: (preferences, reportType) => {
      dispatch(preferencesActions.updatePreferences(
        preferences,
        reportType
      ));
    }
  };
};

const mergeProps = (stateProps, dispatchProps) => {
  return {
    ...stateProps,
    ...dispatchProps,
    updateSectionValue: (title, dataKeyPath) => {
      dispatchProps.updateSectionValue(title, dataKeyPath, stateProps.reportType);
      dispatchProps.sendEvent(stateProps.section, title);
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(CustomiseCustomSection);